













import Vue from 'vue';
import Menu from '@/components/menu.vue';
import HelloWorld from './components/HelloWorld.vue';
import DrawerCondominio from '@/components/DrawerCondominio.vue';
import { mapGetters } from 'vuex';

/* window.onbeforeunload = (event) => {
  if (window.location.href !== 'https://sidra.fcm.com.mx/logout') {
    return confirm('Confirm refresh');
  }
}; */

export default Vue.extend({
  name: 'App',
  components: {
    HelloWorld,
    Menu,
    DrawerCondominio,
  },
  data: () => ({
    state: true,
  }),
  methods: {
    open(event) {
    console.debug('open event: %o', event);
//      this.$router.push('about')
    },
    classes() {
      if (this.$route.name === 'administraciones' || this.$route.name === 'condominiosSelector') {
        return false;
      } else {
          return true;
      }
    },
  },
  computed: {
    ...mapGetters({ showDrawer: 'getShowDrawer' }),
  },
});
